// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"355":"d74ebbb2","453":"b58e54ca"}[chunkId] + ".chunk.js");